var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.06 6H10V2.667C10 2.3 9.7 2 9.333 2H6.666C6.3 2 6 2.3 6 2.667V6H4.94a.669.669 0 0 0-.474 1.14l3.06 3.06c.26.26.68.26.94 0l3.06-3.06c.42-.42.127-1.14-.466-1.14Zm-7.727 6.667c0 .366.3.666.667.666h8c.366 0 .666-.3.666-.666 0-.367-.3-.667-.666-.667H4c-.367 0-.667.3-.667.667Z",
    fill: "#fff"
  })));
};
export default SvgDownloadIcon;